markMutationOptimistic